var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBotaoEditar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#fff",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4330 5105 c-85 -19 -214 -83 -275 -137 -36 -32 -1660 -1803 -2316 -2526 l-58 -63 -145 -438 c-132 -395 -146 -443 -146 -506 0 -191 175 -335 356 -295 67 15 829 348 881 385 33 23 2067 2240 2326 2535 135 154 189 395 131 590 -58 199 -223 370 -421 436 -98 33 -237 41 -333 19z m215 -444 c108 -49 157 -192 97 -283 -27 -40 -1953 -2148 -1964 -2148 -5 0 -74 59 -154 132 l-144 132 38 40 c22 23 465 507 985 1077 741 812 954 1040 984 1052 51 21 109 21 158 -2z m-2225 -2708 l65 -60 -31 -16 c-72 -37 -426 -188 -431 -183 -5 5 131 424 149 459 10 19 9 20 248 -200z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M907 4639 c-232 -24 -451 -132 -614 -302 -128 -133 -208 -280 -256 -467 l-22 -85 0 -1465 0 -1465 28 -100 c92 -337 331 -593 654 -704 151 -51 142 -51 1654 -51 1209 0 1419 2 1493 15 435 76 767 421 825 858 7 50 11 426 11 1051 0 1082 3 1026 -67 1098 -85 87 -221 88 -307 2 -65 -66 -60 14 -66 -1109 l-5 -1020 -22 -66 c-57 -166 -196 -305 -362 -362 l-66 -22 -1410 -3 c-1558 -3 -1484 -6 -1617 60 -86 43 -204 162 -246 248 -64 130 -62 68 -62 1575 0 1511 -2 1441 64 1573 66 132 187 234 336 285 65 22 65 22 1115 27 1157 6 1074 1 1137 67 58 61 74 161 39 239 -26 57 -92 110 -153 123 -59 13 -1960 13 -2081 0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBotaoEditar);
export default __webpack_public_path__ + "static/media/botao-editar.20eb6c8bd5ad2e3d413b3fd23fc143ba.svg";
export { ForwardRef as ReactComponent };